"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicClient = void 0;
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const handleApiError_1 = tslib_1.__importDefault(require("./handleApiError"));
class BasicClient {
    constructor(options) {
        this.requestInterceptors = [];
        this.axiosInstance = axios_1.default.create(options);
    }
    static fromAxiosInstance(axiosInstance) {
        const basicClient = new this();
        basicClient.axiosInstance = axiosInstance;
        basicClient.initialize();
        return basicClient;
    }
    setToken(token) {
        this.ejectInterceptors();
        this.requestInterceptors.push(this.axiosInstance.interceptors.request.use(function (config) {
            config.headers.Authorization = `Bearer ${token}`;
            return config;
        }));
    }
    ejectInterceptors() {
        if (!this.requestInterceptors.length) {
            return;
        }
        console.log('Ejecting axios interceptors');
        this.requestInterceptors.forEach((requestInterceptor) => {
            this.axiosInstance.interceptors.request.eject(requestInterceptor);
        });
        this.requestInterceptors = [];
    }
    initialize() { }
    getBaseUrl() {
        return this.axiosInstance.defaults.baseURL;
    }
    addResponseTramsform(transformer) {
        this.axiosInstance.interceptors.response.use(transformer);
    }
    post(url, data, config) {
        return this.axiosInstance.post(url, data, config);
    }
    patch(url, data, config) {
        return this.axiosInstance.patch(url, data, config);
    }
    put(url, data, config) {
        return this.axiosInstance.put(url, data, config);
    }
    get(url, config) {
        return this.axiosInstance.get(url, config);
    }
    delete(url, config) {
        return this.axiosInstance.delete(url, config);
    }
}
exports.BasicClient = BasicClient;
tslib_1.__decorate([
    handleApiError_1.default
], BasicClient.prototype, "post", null);
tslib_1.__decorate([
    handleApiError_1.default
], BasicClient.prototype, "patch", null);
tslib_1.__decorate([
    handleApiError_1.default
], BasicClient.prototype, "put", null);
tslib_1.__decorate([
    handleApiError_1.default
], BasicClient.prototype, "get", null);
tslib_1.__decorate([
    handleApiError_1.default
], BasicClient.prototype, "delete", null);
//# sourceMappingURL=BasicClient.js.map